import { render } from "./vmwarevsphere.vue?vue&type=template&id=355ffd03"
import script from "./vmwarevsphere.vue?vue&type=script&lang=js"
export * from "./vmwarevsphere.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__